import fetcher from 'api/fetcher';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import { setIncomeExpenseData, setLoadIncomeExpenseData } from 'store/models/incomeExpense';

export default () => {
    return (dispatch, getState) => {
        dispatch(setLoadIncomeExpenseData(true));
        const { from, to, typeReport, vat } = getState().incomeExpense;
        const queryStr = urlParser.stringify({
            dateFrom: formatDate(from),
            dateTo: formatDate(to),
            vat,
            type: typeReport,
        });
        return fetcher
            .get(`/api/v1/report/monthlyoutcome?${queryStr}`)
            .then((data) => {
                dispatch([setIncomeExpenseData(data), setLoadIncomeExpenseData(false)]);
            })
            .catch(() => {
                dispatch([setIncomeExpenseData([]), setLoadIncomeExpenseData(false)]);
            });
    };
};
